// @flow
export const initializeTypes = {
  APP: 'app',
  REFRESH_TOKEN: 'refreshToken',
}
